import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { taxonomyVersionsSearchSchema } from '~/features/taxonomy-studio/utils/taxonomy-search';

const VersionsPage = lazy(() => import('~/features/taxonomy-studio/pages/versions-page'));

/** Taxonomy Studio — releases, their changes and the audit trail. */
export const Route = createFileRoute('/_authenticated/_tenant/taxonomy/versions')({
  validateSearch: taxonomyVersionsSearchSchema,
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <VersionsPage />
    </Suspense>
  ),
});
